export interface PredictedVolumeCapsuleConfigState {
    includePredContinuousTrading: boolean;
    symbol?: string;
}

export const initialPredictedRemainingVolumeCapsuleConfigState: PredictedVolumeCapsuleConfigState =
    {
        includePredContinuousTrading: true,
    };

export const initialPredictedCloseVolumeCapsuleConfigState: PredictedVolumeCapsuleConfigState =
    {
        includePredContinuousTrading: false,
    };
